/* import __COLOCATED_TEMPLATE__ from './edit-payout-account.hbs'; */
import { Promise } from 'rsvp';
import Component from '@ember/component';
import { closeModal } from 'sh-www/utils/modal-controls'

export default Component.extend({
  /** @inheritDoc */
  tagName: '',

  actions: {
    handleSubmit(providerId, status) {
      const payoutAccount = this.get('model.payoutAccount');
      const setProviderId = this.get('model.onSetProviderId').perform(payoutAccount, providerId);
      const setStatus = this.get('model.onSetStatus').perform(payoutAccount, status);

      return Promise.all([setProviderId, setStatus])
        .then(() => closeModal(this));
    },

    handleClose() {
      closeModal(this);
    },
  },
});
